import { render, staticRenderFns } from "./TabelaNotasParciais.vue?vue&type=template&id=0e7522aa&"
import script from "./TabelaNotasParciais.vue?vue&type=script&lang=js&"
export * from "./TabelaNotasParciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports